class AnalyticsService {
    /**
     * Normalizes V2 analytics response by adding graphData from value object.
     * When `value` is an object (distribution data), it creates `graphData: [value]`
     * to maintain compatibility with components that expect graphData.
     */
    normalizeV2AnalyticsWithGraphData = (analytics) => {
        if (!analytics) {
            return analytics;
        }

        const transformed = {};

        Object.keys(analytics).forEach((fieldKey) => {
            const fieldData = analytics[fieldKey];
            if (!fieldData) {
                transformed[fieldKey] = fieldData;
                return;
            }

            const isValueObject =
                typeof fieldData.value === 'object' &&
                fieldData.value !== null &&
                !Array.isArray(fieldData.value);

            transformed[fieldKey] = isValueObject
                ? { ...fieldData, graphData: [fieldData.value] }
                : fieldData;
        });

        return transformed;
    };
}

const analyticsService = new AnalyticsService();

export { analyticsService as AnalyticsService };
